import { render, staticRenderFns } from "./FRedirect.vue?vue&type=template&id=43f99a21&"
import script from "./FRedirect.vue?vue&type=script&lang=ts&"
export * from "./FRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports